(function(root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.BentleyPaymentReceipt = api;
})(typeof window !== 'undefined' ? window : this, function() {
  var key = 'bentley.payment.receipt.v1',
    lifetime = 60 * 60 * 1000;
  function money(n, signed) {
    if (typeof n !== 'number' || !Number.isFinite(n) || Math.abs(n) > 1e9 || (!signed && n < 0))
      throw new Error('Invalid amount');
    return n;
  }
  function receipt(raw) {
    if (
      !raw ||
      typeof raw.orderId !== 'string' ||
      !/^[a-f0-9]{24}$/.test(raw.orderId) ||
      typeof raw.apiBase !== 'string' ||
      raw.apiBase.replace(/\/$/, '') !== 'https://api.preprod2.bp.squadintouch.com' ||
      !Array.isArray(raw.items) ||
      !raw.items.length ||
      raw.items.length > 500
    )
      throw new Error('Invalid receipt');
    return {
      orderId: raw.orderId,
      amount: money(raw.amount),
      apiBase: raw.apiBase.replace(/\/$/, ''),
      items: raw.items.map(function(row) {
        if (
          !row ||
          typeof row.name !== 'string' ||
          !row.name.length ||
          row.name.length > 300 ||
          /[\x00-\x1f]/.test(row.name) ||
          !Number.isSafeInteger(row.quantity) ||
          row.quantity < 1 ||
          row.quantity > 100000
        )
          throw new Error('Invalid item');
        return {
          name: row.name,
          quantity: row.quantity,
          unitPrice: money(row.unitPrice),
          baseUnitPrice: money(row.baseUnitPrice),
        };
      }),
    };
  }
  function save(storage, host, input, now, bridge) {
    if (host !== 'orders.preprod2.bp.squadintouch.com' || !bridge.hosted(input.hostedUrl))
      throw new Error('Invalid destination');
    var data = receipt(input.receipt),
      url = new URL(input.hostedUrl);
    var sessionId = decodeURIComponent(url.pathname.split('/').pop());
    storage.setItem(key, JSON.stringify({ receipt: data, sessionId: sessionId, expires: now + lifetime }));
  }
  function read(storage, host, now) {
    try {
      var raw = JSON.parse(storage.getItem(key));
      if (host !== 'orders.preprod2.bp.squadintouch.com' || !raw) return;
      if (!Number.isFinite(raw.expires) || raw.expires <= now || raw.expires > now + lifetime) {
        clear(storage);
        return;
      }
      if (
        typeof raw.sessionId !== 'string' ||
        raw.sessionId.length > 200 ||
        !/^[A-Za-z0-9_-]+={0,2}$/.test(raw.sessionId)
      )
        return;
      return { receipt: receipt(raw.receipt), sessionId: raw.sessionId, expires: raw.expires };
    } catch (error) {
      return;
    }
  }
  function clear(storage) {
    storage.removeItem(key);
  }
  function sourceOrder(raw, context) {
    if (
      !raw ||
      (raw.id || raw._id) !== context.receipt.orderId ||
      raw.pay360SessionId !== context.sessionId ||
      money(raw.orderAmount) !== context.receipt.amount ||
      typeof raw.orderStatus !== 'string'
    )
      throw new Error('Order mismatch');
    var result = {
      orderStatus: raw.orderStatus,
      orderNumber:
        typeof raw.orderNumber === 'string' && /^[A-Za-z0-9][A-Za-z0-9._/-]{0,79}$/.test(raw.orderNumber)
          ? raw.orderNumber
          : undefined,
      total: raw.orderAmount,
    };
    [
      'totalWithSpecialOffers',
      'totalWithoutSpecialOffers',
      'deliveryAmount',
      'voucherSaving',
      'specialOffersSaving',
    ].forEach(function(field) {
      if (raw[field] != null) result[field] = money(raw[field], field === 'specialOffersSaving');
    });
    return result;
  }
  function status(value) {
    if (['PAID', 'DOWNLOADED', 'DISPATCHED'].indexOf(value) >= 0)
      return {
        title: 'Payment successful',
        text: 'Thank you. Your order has been placed.',
        kind: 'success',
        terminal: true,
      };
    if (value === 'CANCELED')
      return {
        title: 'Payment canceled',
        text: 'Payment has not been confirmed for this order.',
        kind: 'failure',
        terminal: true,
      };
    if (value === 'FAILED')
      return {
        title: 'Payment failed',
        text: 'Payment has not been confirmed for this order.',
        kind: 'failure',
        terminal: true,
      };
    return {
      title: 'Payment processing',
      text: 'We are waiting for confirmation. Please do not pay again.',
      kind: 'pending',
      terminal: false,
    };
  }
  return { save: save, read: read, clear: clear, sourceOrder: sourceOrder, status: status };
});
